<script setup lang="ts">
import AdSlot from '../components/AdSlot.vue';
import { AD_SIZE_PRESETS } from '../config/ads';
</script>

<template>
  <div class="content-page">
    <section class="content-hero">
      <p class="page-badge">Política de Privacidade</p>
      <h1>Como tratamos seus dados</h1>
      <p class="hero-lead">
        Mantemos a experiência do VemChuva Brasil simples e segura. Não exigimos cadastro e só usamos dados essenciais
        para funcionamento, estatísticas anônimas e exibição responsável de anúncios.
      </p>
      <div class="page-meta">
        <span>Última atualização: fevereiro de 2025</span>
        <span>Contato: <a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a></span>
      </div>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.top"
    />

    <section class="content-section">
      <h2>Dados que coletamos</h2>
      <div class="content-grid two">
        <article class="content-card">
          <h3>Essenciais para funcionamento</h3>
          <ul>
            <li>Preferências locais (tema, raio de busca, últimas cidades) armazenadas apenas no seu dispositivo.</li>
            <li>Consultas de cidades e datas, usadas apenas para responder à sua pesquisa.</li>
          </ul>
        </article>
        <article class="content-card">
          <h3>Analytics e desempenho</h3>
          <p>Usamos monitoramento de performance (Datadog RUM) para métricas agregadas de navegação. Os dados são anônimos, usados para detectar erros e melhorar estabilidade.</p>
        </article>
      </div>
    </section>

    <section class="content-section">
      <h2>Cookies e tecnologias similares</h2>
      <div class="content-grid two">
        <article class="content-card">
          <h3>Armazenamento local</h3>
          <p>Guardamos tema, raio, últimas cidades e cache de previsões no seu próprio navegador (LocalStorage/IndexedDB). Não enviamos essas informações para servidores.</p>
        </article>
        <article class="content-card">
          <h3>Google AdSense</h3>
          <p>O AdSense pode utilizar cookies e identificadores para personalizar anúncios e limitar repetição. Você pode desativar personalização em <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener">adssettings.google.com</a> e saber mais em <a href="https://policies.google.com/technologies/partner-sites?hl=pt-BR" target="_blank" rel="noopener">políticas do Google</a>.</p>
        </article>
      </div>
    </section>

    <section class="content-section">
      <h2>Finalidades de uso</h2>
      <ul class="highlight-list">
        <li>Exibir previsões meteorológicas e alertas conforme sua busca.</li>
        <li>Personalizar a interface (tema, idioma e raio padrão).</li>
        <li>Manter a qualidade do serviço com métricas agregadas e detectar erros técnicos.</li>
        <li>Veicular anúncios em conformidade com as políticas do Google AdSense.</li>
      </ul>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.middle"
    />

    <section class="content-section">
      <h2>Compartilhamento de dados</h2>
      <p>Não vendemos informações pessoais. Compartilhamos apenas com provedores estritamente necessários:</p>
      <ul>
        <li><strong>Google AdSense</strong> para exibição de anúncios.</li>
        <li><strong>Datadog</strong> para métricas de performance e erros, sem identificar usuários.</li>
      </ul>
    </section>

    <section class="content-section">
      <h2>Segurança</h2>
      <p>O site utiliza HTTPS/TLS. Dados armazenados localmente permanecem no seu dispositivo. Relatórios de erros são mínimos e usados somente para corrigir falhas.</p>
    </section>

    <section class="content-section">
      <h2>Seus controles</h2>
      <ul class="highlight-list">
        <li>Limpar cookies/armazenamento local no navegador para remover preferências salvas.</li>
        <li>Desativar personalização de anúncios nas configurações do Google.</li>
        <li>Solicitar esclarecimentos ou exclusão de registros de erro via <a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a>.</li>
      </ul>
    </section>

    <section class="content-section">
      <h2>Crianças</h2>
      <p>O VemChuva Brasil não é direcionado a crianças menores de 13 anos. Não coletamos dados intencionalmente desse público.</p>
    </section>

    <section class="content-section">
      <h2>Alterações</h2>
      <p>Quando atualizarmos esta política, indicaremos a data de revisão. Mudanças relevantes serão destacadas no site.</p>
    </section>

    <section class="content-section">
      <h2>Contato</h2>
      <p>Em caso de dúvidas de privacidade, envie um e-mail para <a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a>.</p>
    </section>
  </div>
</template>
